import Vue from 'vue';
import VueAppleSignin from 'vue-apple-signin';

Vue.use(VueAppleSignin, {
  clientId: 'net.vindome.devsite',
  scope: 'name email',
  redirectURI: 'https://blog.vindome.net/wp-content/themes/twentynineteen/search.php',
  state: 'appleState',
});
